<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent != null && localService.languageContent.appointments != undefined">
  <app-popup-header title="{{localService.languageContent.appointments.header}}"></app-popup-header>
  <div class="modal-body modal-body-no-flexible-height" *ngIf="content">
    <div class="row">
      <div class="col-md-12">
        <app-working-hours-range [workingRangeType]="workingRangeType" [selectedRange]="appointmentDate" [isReadOnly]="isViewMode || content.v7 != '0'" (onRangeUpdated)="onDateUpdate($event)"  [IsMandatory]="true"></app-working-hours-range>
      </div>
    </div>
    <div class="row" *ngIf="appointmentDate">
      <div class="col-12" style="text-align:center;color:deeppink">
        <span>{{localService.languageContent.appointments.expiry_date}}</span>
        <span class="en">&nbsp;:&nbsp;{{localService.getDateFromRange(appointmentDate,7,1) | localDate}}</span>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-4 label_right">
        <app-label [Text]="localService.languageContent.appointments.customer" [IsMandatory]="true"></app-label>
      </div>
      <div class="col-8">
        <app-business-relationship [businessId]="content.v4" [currentUserId]="content.v3" [isReadOnly]="isViewMode || content.v7 != '0'" (onUserUpdated)="onUserUpdated($event,1)" [relationShipType]="relationShipType" [relationShipRole]="3"></app-business-relationship>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-4 label_right">
        <app-label [Text]="localService.languageContent.appointments.service_provider" [IsMandatory]="true"></app-label>
      </div>
      <div class="col-8">
        <app-business-relationship [businessId]="content.v4" [currentUserId]="content.v6" [isReadOnly]="isViewMode || content.v7 != '0' || appointmentType == 2" (onUserUpdated)="onUserUpdated($event,2)" [relationShipType]="relationShipType" [relationShipRole]="2"></app-business-relationship>
      </div>
    </div>
    <div class="row">
      <div class="col-4 label_right">
        <app-label [Text]="localService.languageContent.appointments.notes"></app-label>
      </div>
      <div class="col-8">
        <textarea [(ngModel)]="content.v5" rows="3" [readonly]="isViewMode || content.v7 != '0'"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="content && content.v7 != '0'">
    <span style="color: orangered">{{localService.languageContent.appointments.cancelled}}</span>
    <br/>
    <span class="en">{{content.v7 | localDate}}&nbsp;/&nbsp;</span>
    <span [ngClass]="localService.getLanguageCode(content.v9)">{{content.v8}}</span>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()" *ngIf="!isViewMode && content && content.v7 == '0'">{{localService.languageContent.common.save}}</button>
  </div>
</div>
